__turbopack_context__.v({
  "IconWrap": "MeetTeam-module__1BXVTW__IconWrap",
  "TeamBox": "MeetTeam-module__1BXVTW__TeamBox",
});
